import React from 'react';
import FormStarProvider from './FormStarProvider';
import { Form } from 'antd';

const SearchStarProviders: React.FC<any> = (props) => {
  const { getList, setPaginationData } = props;
  const [form] = Form.useForm();

  const handleSearchSubmit = (data?: any) => {
    const payload = {
      ...data,
      pageNumber: 1,
      pageSize: 10,
    };
    setPaginationData({
      pageNumber: 1,
      pageSize: 10,
    });
    getList(payload);
  };

  return (
    <FormStarProvider
      form={form}
      handleSearchSubmit={handleSearchSubmit}
      mode={'search'}
    />
  );
};
export default SearchStarProviders;
